export const languageReducer = (state = { lang: 'en' }, action) => {
    switch (action.type) {
        case 'SET_LANGUAGE':
            localStorage.setItem('siteLang', action.payload);
            return { lang: action.payload };
        default:
            return state;
    }
};